"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toImageEntity = exports.scrollToCategoryPhotosBlock = exports.generateCategoryPhotosBlockID = exports.createSizesPlaceholder = exports.createPhotosGroupsNext = void 0;
var R = _interopRequireWildcard(require("ramda"));
var _reactScroll = require("react-scroll");
var _constants = require("./constants");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var createSizesPlaceholder = exports.createSizesPlaceholder = function createSizesPlaceholder(items) {
  return R.map(R.always(null), R.range(0, items.length));
};
var toImageEntity = exports.toImageEntity = function toImageEntity(src) {
  return R.call(function (img) {
    return img.src = src, img;
  }, new Image());
};
var convertGroupsCountToStrategyIndex = function convertGroupsCountToStrategyIndex(groupsCount) {
  return groupsCount < _constants.STRATEGIES_RENDERING_GROUPS.length ? groupsCount : R.call(R.pipe(R.when(function (count) {
    return "".concat(count).length > 1;
  }, R.pipe(R.toString, R.split(''), R.last, Number)), function (count) {
    return count < _constants.STRATEGIES_RENDERING_GROUPS.length ? count : count - _constants.STRATEGIES_RENDERING_GROUPS.length;
  }), groupsCount);
};
var createGroup = function createGroup(photos, GROUP_META) {
  return {
    photos: photos,
    strategyIndex: GROUP_META.INDEX
  };
};
var isVerticalPhoto = function isVerticalPhoto(photo) {
  return R.call(function (_ref) {
    var height = _ref.height,
      width = _ref.width;
    return height > width;
  }, photo);
};
var getLastStrategy = function getLastStrategy(groups) {
  return R.call(R.pipe(R.last, R.when(Boolean, function (_ref2) {
    var strategyIndex = _ref2.strategyIndex;
    return _constants.STRATEGIES_META[strategyIndex];
  })), groups);
};
var injectOrientationToPhoto = function injectOrientationToPhoto(photo) {
  return R.set(R.lensProp('orientation'), isVerticalPhoto(photo) ? _constants.VERTICAL_ORIENTATION_PHOTO : _constants.HORIZONTAL_ORIENTATION_PHOTO, photo);
};
var createGroupByStrategy = function createGroupByStrategy(photos, GROUP_META) {
  var SIZE = GROUP_META.SIZE,
    ORIENTATIONS = GROUP_META.ORIENTATIONS;
  return R.call(R.pipe(R.take(SIZE), R.map(injectOrientationToPhoto), R.addIndex(R.filter)(function (_ref3, index) {
    var orientation = _ref3.orientation;
    return orientation === ORIENTATIONS[index];
  }), function (nextPhotos) {
    return R.equals(nextPhotos.length, SIZE) ? createGroup(R.map(R.prop('src'), nextPhotos), GROUP_META) : undefined;
  }), photos);
};
var createLastGroupByStrategy = function createLastGroupByStrategy(photos, GROUP_META) {
  var SIZE = GROUP_META.SIZE,
    ORIENTATIONS = GROUP_META.ORIENTATIONS;
  return R.call(R.pipe(R.take(SIZE), R.map(injectOrientationToPhoto), R.filter(function (_ref4) {
    var orientation = _ref4.orientation;
    return R.includes(orientation, ORIENTATIONS);
  }), function (nextPhotos) {
    return R.equals(nextPhotos.length, SIZE) ? R.call(R.pipe(R.reduce(function (acc, orientation) {
      return R.append(R.find(function (photo) {
        return R.equals(photo.orientation, orientation) && !R.includes(photo, acc);
      }, nextPhotos), acc);
    }, []), R.map(R.prop('src')), function (photosByStrategyDirection) {
      return createGroup(photosByStrategyDirection, GROUP_META);
    }), ORIENTATIONS) : undefined;
  }), photos);
};
var generateStrategiesListByPriorityIndex = function generateStrategiesListByPriorityIndex(index) {
  return [].concat(_toConsumableArray(R.drop(R.inc(index), _constants.STRATEGIES_META)), _toConsumableArray(R.take(R.inc(index), _constants.STRATEGIES_META)));
};
var isLastGroup = function isLastGroup(photos) {
  return R.length(photos) === 3;
};
var MAX_ITERATIONS = 1000;
var createPhotosGroupsNext = exports.createPhotosGroupsNext = function createPhotosGroupsNext(photos) {
  var copyPhotos = R.clone(photos);
  var groups = [];
  var countItertations = 0;
  var _loop = function _loop() {
    var mbNextStrategyGroup = _constants.STRATEGIES_META[convertGroupsCountToStrategyIndex(groups.length)];
    var mbNextGroup = createGroupByStrategy(copyPhotos, mbNextStrategyGroup);
    var prevStrategy = getLastStrategy(groups);
    countItertations += 1;
    if (countItertations > MAX_ITERATIONS) {
      return 1; // break
    }
    if (mbNextGroup && prevStrategy !== mbNextStrategyGroup) {
      var SIZE = mbNextStrategyGroup.SIZE;
      R.range(0, SIZE).forEach(function () {
        return copyPhotos.shift();
      });
      groups.push(mbNextGroup);
    } else if (isLastGroup(copyPhotos)) {
      var nextStrategy = R.call(R.pipe(R.filter(function (strategy) {
        return strategy !== prevStrategy;
      }), R.sort(R.descend(R.prop('SIZE'))), R.find(function (strategy) {
        return createLastGroupByStrategy(copyPhotos, strategy);
      })), _constants.STRATEGIES_META);
      if (nextStrategy) {
        groups.push(createLastGroupByStrategy(copyPhotos, nextStrategy));
        R.range(0, nextStrategy.SIZE).forEach(function () {
          return copyPhotos.shift();
        });
      }
    } else {
      R.call(R.pipe(convertGroupsCountToStrategyIndex, generateStrategiesListByPriorityIndex, R.when(function (strategies) {
        return strategies.length > 1;
      }, R.filter(function (strategy) {
        return strategy !== prevStrategy;
      })), R.find(function (strategy) {
        return createGroupByStrategy(copyPhotos, strategy);
      }), function (strategy) {
        if (!strategy) {
          var _copyPhotos = _slicedToArray(copyPhotos, 1),
            photo = _copyPhotos[0];
          var _nextStrategy = isVerticalPhoto(photo) ? _constants.DOUBLE_VERTICAL_STRATEGY_META : _constants.SINGLE_HORIZONTAL_STRATEGY_META;
          var nextGroup = R.or(createGroupByStrategy(copyPhotos, _nextStrategy), createGroup([photo.src], _nextStrategy));
          return groups.push(nextGroup), R.range(0, nextGroup.photos.length).forEach(function () {
            return copyPhotos.shift();
          });
        }
        return groups.push(createGroupByStrategy(copyPhotos, strategy)), R.range(0, strategy.SIZE).forEach(function () {
          return copyPhotos.shift();
        });
      }), groups.length);
    }
  };
  while (copyPhotos.length) {
    if (_loop()) break;
  }
  return groups;
};
var generateCategoryPhotosBlockID = exports.generateCategoryPhotosBlockID = function generateCategoryPhotosBlockID(id) {
  return "".concat(id, "--category-photos-block");
};
var scrollToCategoryPhotosBlock = exports.scrollToCategoryPhotosBlock = function scrollToCategoryPhotosBlock(id) {
  return _reactScroll.scroller.scrollTo(generateCategoryPhotosBlockID(id), {
    duration: 500,
    delay: 0,
    smooth: true,
    isDynamic: true,
    containerId: _constants.CATEGORIES_PHOTOS_BLOCK_ID,
    offset: 0.5
  });
};